module.exports = __webpack_public_path__ + "static/media/progger2.fa48aefa.png";